export const Role = {
  User: 1,
  Dev: 2,
  Admin: 4,
};

export const GroupMembershipType = {
  Public: 0,
  InviteOnly: 1,
};
